"use strict";

var constants = require("./index");

module.exports = constants(["FETCH_FAILED"]);


/*****************
 ** WEBPACK FOOTER
 ** ./~/marty/dist/node/lib/constants/store.js
 ** module id = 479
 ** module chunks = 0
 **/